import { apiRoutes } from '../../api-routes';
import { apiUrl } from '../../constants';
import { type AxiosRequestConfig, httpClient } from '../../util';
import type { RecentLocation } from './types';

export const getRecentLocationFn = async (config: AxiosRequestConfig = {}) => {
  const response = await httpClient.get<RecentLocation[]>(
    apiUrl + apiRoutes.place.user_places.recent_location,
    config
  );

  return response.data;
};
